import { sortBy } from 'underscore';
import { Distance, namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import AbstractCommand from './abstractCommand';

/**
 * @param {Bounds} bounds
 * @param {string} axis
 * @return {number}
 */
function getSizeByAxis(bounds, axis) {
    const sizeFunctionName = {
        x: 'getWidth',
        y: 'getHeight',
    };
    return bounds[sizeFunctionName[axis]]();
}

/**
 * @param {AbstractItem[]} items
 * @param {Bounds} areaBounds
 * @param {string} axis
 * @param {number} margin
 */
function repositionItems(items, areaBounds, axis, margin) {
    let currentPosition = areaBounds.getTopLeft()[axis];

    items.forEach((item) => {
        const initialPosition = item.get('position').clone();
        const itemBounds = item.getBounds();
        const halfItemWidth = getSizeByAxis(itemBounds, axis) / 2;
        const distance = new Distance(initialPosition, itemBounds.getCenter()).point;

        currentPosition += halfItemWidth;
        initialPosition[axis] = currentPosition - distance[axis];
        item.set('position', initialPosition);
        currentPosition += halfItemWidth + margin;
    });
}

/**
 * Spread items by margin command
 *
 * @class SpreadItemsByMarginCommand
 * @extends AbstractCommand
 */
export default class SpreadItemsByMarginCommand extends AbstractCommand {
    constructor(items, spreadVertical) {
        super();

        if (!Array.isArray(items) || items.length <= 1) {
            throw new Error('Too few items are selected.');
        }

        this.items = items;
        this.alignVertical = !!spreadVertical;
        this.initialPositions = {};

        this.items.forEach(item => (this.initialPositions[item.cid] = item.get('position').clone()));
    }

    /**
     * Execute command
     */
    execute() {
        const axisArray = this.alignVertical ? ['y', 'x'] : ['x', 'y'];
        let usedSpace = 0;
        let areaBounds;

        const sortedItems = sortBy(this.items, (item) => {
            const itemBounds = item.getBounds();
            const itemPosition = itemBounds.getCenter();

            usedSpace += getSizeByAxis(itemBounds, axisArray[0]);

            if (areaBounds) areaBounds = areaBounds.merge(itemBounds);
            else areaBounds = itemBounds.clone();

            return (itemPosition[axisArray[0]] * 100000) + itemPosition[axisArray[1]];
        });

        const remainingSpace = getSizeByAxis(areaBounds, axisArray[0]) - usedSpace;
        const margin = remainingSpace / (sortedItems.length - 1);

        repositionItems(sortedItems, areaBounds, axisArray[0], margin);
    }

    /**
     * Unexecute command
     */
    unexecute() {
        this.items.forEach(item => item.set('position', this.initialPositions[item.cid]));
    }

    /**
     * Return title
     *
     * @return {string}
     */
    getTitle() {
        return `Spread items by margin ${this.alignVertical ? 'vertical' : 'horizontal'}`;
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.SpreadItemsByMarginCommand = SpreadItemsByMarginCommand;
